import { hasPermission } from '@/hooks/useBackendMenu'
import { parseDataTransform, uploadFile } from '@acme/common'
import Dialog from 'global/guides/Dialog'
import { SubmitHandler } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { Abono, abonos, createAbonoSchema } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { LancamentosAnterioresAsync } from 'templates/ManutencaoDoPonto/Ausencias/lancamentos-anteriores'
import { useUpdateDigitacaoQueryData } from 'templates/ManutencaoDoPonto/Digitacao/pages/useDigitacaoData'
import FormNovoAbono from '../forms/NovoAbono'
import { funcionarioPodeSolicitarAjustes } from './DetalhesRegistros'

const baseUrl = import.meta.env.VITE_BASE_URL

export default function NovoAbonoModal() {
    const { mutateAsync, isLoading } = abonos.mutations.useCreate()
    const { setQueryData } = useUpdateDigitacaoQueryData()
    const { dia } = useParams()

    const funcionarioId = useStore(state => state.employeeId)
    const empresaId = useStore(state => state.companyId)

    const handleSubmit: SubmitHandler<Abono> = async ({ fileUrl, ...data }) => {
        const filename = await uploadFile(fileUrl!, baseUrl)

        const json = {
            ...parseDataTransform(data),
            fileUrl: filename,
            funcionarioId,
            empresaId,
            origem: 1,
            tipo: data.tipo || 'NORMAL',
        } as Abono

        await mutateAsync(json, {
            onSuccess: payload => {
                setQueryData('ABONO', payload)
                toast.success('Abono adicionado com sucesso!')
            },
            onError: err => {
                toast.error(err.message)
            },
        })
    }

    return (
        <Dialog.Root
            height="auto"
            onSubmit={handleSubmit}
            loading={isLoading}
            defaultValues={{
                data: dia,
                tipo: 'NORMAL',
            }}
            schema={createAbonoSchema}
            open={
                hasPermission(['create', 'Abonos']) ||
                funcionarioPodeSolicitarAjustes()
            }
        >
            <Dialog.Title>Novo abono</Dialog.Title>
            <Dialog.Content dividers>
                <FormNovoAbono />
                <LancamentosAnterioresAsync tipoAusencia="Abono" />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
